import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { LocationQuery } from 'vue-router';

export class PersonAddressTypeService {
   async getPersonAddressTypes(query?: LocationQuery) {
      const response = await http.get(`/person-address-types`, { ...cacheFirstConfig, params: { ...query } });
      return response.data;
   }
}
